import React from 'react';
import PropTypes from 'prop-types';

import { Typography, Tooltip } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import InfoCard from './InfoCard';
import PotentialUnitsText from '../../../Common/UI/PotentialUnitsText';

function PotentialUnitsInfoCard ({ isLoading, area, buildableArea }) {
    return (<InfoCard skeleton={isLoading}>
        <Typography>
            Potential units
            <Tooltip arrow title={'Potential units calculated by assuming a property size of 130m² (house and garden) and 75% allocated to infrastructure and greenspace on the buildable area of this title'} placement={'right'}>
                <InfoOutlinedIcon />
            </Tooltip>
        </Typography>
        <Typography>
            <HomeIcon />
            {!isLoading && <PotentialUnitsText area={area} buildableArea={buildableArea} />}
        </Typography>
    </InfoCard>);
}

PotentialUnitsInfoCard.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    area: PropTypes.number.isRequired,
    buildableArea: PropTypes.number.isRequired
};

export default PotentialUnitsInfoCard;